import { Component } from '@theme/component';

// Visibility is observed per link so off-screen touch scenes remain paused.
class HolidayMotion extends Component {
  #observer;
  connectedCallback() { super.connectedCallback(); this.#observe(); }
  updatedCallback() { super.updatedCallback(); this.#observe(); }
  disconnectedCallback() { super.disconnectedCallback(); this.#observer?.disconnect(); }
  #observe() {
    this.#observer?.disconnect();
    if (!('IntersectionObserver' in window)) return;
    this.#observer = new IntersectionObserver(entries => {
      for (const entry of entries) entry.target.toggleAttribute('data-in-view', entry.isIntersecting);
    }, { threshold: .2 });
    for (const link of this.querySelectorAll('.vx-holiday-link')) this.#observer.observe(link);
  }
}
if (!customElements.get('vx-holiday-motion')) customElements.define('vx-holiday-motion', HolidayMotion);
